import { withRBAC } from "../rbac";
import { EnquiryCreate } from "./EnquiryCreate";
import { EnquiryEdit } from "./EnquiryEdit";
import { EnquiryList } from "./EnquiryList";
import { EnquiryShow } from "./EnquiryShow";

export const enquiries = {
  list: withRBAC(EnquiryList, "view_all_data"),       // Using a generic view permission or custom
  show: withRBAC(EnquiryShow, "view_all_data"),
  create: withRBAC(EnquiryCreate, "manage_documents"), // Assuming manage_documents covers enquiries as per old spec
  edit: withRBAC(EnquiryEdit, "manage_documents"),
  recordRepresentation: "reference",
};
